
/* intro animation */
$(document).ready(function () {

	if ($("#intro-water-wrapper").length) {



		window.introVideo = document.getElementById('introVideo');
		// window.introVideo.currentTime = 19;
		// window.introVideo.pause();

		product = $("#intro-product");
		leaf_wrapper = $("#intro-leaf-wrapper");
		header_cont = $("#header-container");
		text_last = $("#intro_text_5");


		// function checkForMobile() {
		// 	if (isMobile()) {
		// 		// skipIntro();
		// 		// tl.pause();
		// 		// tl.progress(1);
		// 	}
		// }


		function skipIntro() {
			console.log("skipIntro");

			unRegisterSkip();
			initStickies();

			videoFinished();
		}

		function registerSkip() {
			if ($(window).scrollTop() > 0) {
				skipIntro();
			}
			else {
				$(window).bind("scroll", function () {
					// console.log("scrolled...");
					skipIntro();
				});
			}
		}

		function unRegisterSkip() {
			// console.log("unRegisterSkip...");
			$(window).unbind("scroll");
		}


		// videoFinished();

		function videoFinished() {
			//TODO: not for mobile
			console.log("videoFinished");
			window.introVideo.pause();
			TweenMax.to(window.introVideo, 1, {
				autoAlpha: 0,
				onComplete: function () {
					window.introVideo.remove();
				}
			}, 0);
			TweenMax.to($('#link-down'), 0.5, {
				color: "#003613",
			}, 0);

			TweenMax.to($('#intro-logo'), 0.5, {
				autoAlpha: 0,
			}, 0);

			TweenMax.to(leaf_wrapper, 4, {
				yoyo: true,
				repeat: -1,
				rotation: "4",
				transformOrigin: "right top",
				ease: Cubic.easeInOut
			}), 0;
			TweenMax.to(header_cont, 1, { height: '-=110', delay: 1 });
		}

		window.introVideo.addEventListener('ended', function () {
			console.log('Video has finished playing!');
			skipIntro();
		});


		/*

		$(window).resize(debounce(
			function () {

				if ($("#header-container").length) {
					centerHeader();
				}
				else $(window).off("resize");
			}
			, 500));


		function centerHeader() {

			if (isMobile()) {
				// console.log("centerHeader auto");				
				$("#header-container").height("auto");
			}
			else {
				$("#header-container").height($(window).height());
			}

		}

		centerHeader();
*/
		registerSkip();

	} //end if itro

	else { //no intro
		initStickies();
	}

});


function isMobile() {
	return $("#breakPointHookXS").is(':hidden');
}
